"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalDetailsPage = void 0;
var react_1 = __importStar(require("react"));
var doshx_controls_web_1 = require("doshx_controls_web");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var firestore_1 = require("firebase/firestore");
var update_advanced_user_details_1 = require("../../../api/calls/user/update_advanced_user_details");
var get_user_details_1 = require("../../../api/calls/user/get_user_details");
var address_list_1 = require("../../../api/calls/user/address_list");
var main_1 = require("../../../reducers/slices/main");
var functions_1 = require("../../../constants/functions");
var personal_details_1 = require("../../../constants/personal_details");
var page_path_1 = require("../components/page_path");
var AddressManager_1 = __importDefault(require("../../../components/AddressManager"));
var PersonalDetailsPage = function () {
    var _a, _b, _c;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _d = (0, react_1.useState)(""), name = _d[0], setName = _d[1];
    var _e = (0, react_1.useState)(""), surname = _e[0], setSurname = _e[1];
    var _f = (0, react_1.useState)(""), idNumber = _f[0], setIdNumber = _f[1];
    var _g = (0, react_1.useState)(""), gender = _g[0], setGender = _g[1];
    var _h = (0, react_1.useState)(false), married = _h[0], setMarried = _h[1];
    var _j = (0, react_1.useState)(""), marriageType = _j[0], setMarriageType = _j[1];
    // Address state - using new AddressManager
    var _k = (0, react_1.useState)(null), selectedHomeAddress = _k[0], setSelectedHomeAddress = _k[1];
    var _l = (0, react_1.useState)(null), selectedPostalAddress = _l[0], setSelectedPostalAddress = _l[1];
    var _m = (0, react_1.useState)(""), homeErf = _m[0], setHomeErf = _m[1];
    //Spouse Details
    var _o = (0, react_1.useState)(""), spouseNameMessage = _o[0], setSpouseNameMessage = _o[1];
    var _p = (0, react_1.useState)(""), spouseSurnameMessage = _p[0], setSpouseSurnameMessage = _p[1];
    var _q = (0, react_1.useState)(""), spouseCellNumberMessage = _q[0], setSpouseCellNumberMessage = _q[1];
    var _r = (0, react_1.useState)(""), spouseHomeNumberMessage = _r[0], setSpouseHomeNumberMessage = _r[1];
    var _s = (0, react_1.useState)(""), spouseWorkNumberMessage = _s[0], setSpouseWorkNumberMessage = _s[1];
    var _t = (0, react_1.useState)(""), spouseName = _t[0], setSpouseName = _t[1];
    var _u = (0, react_1.useState)(""), spouseSurname = _u[0], setSpouseSurname = _u[1];
    var _v = (0, react_1.useState)({ phone_number: "", country_code: "+267", country_abbreviation: "BW" }), spouseCellNumber = _v[0], setSpouseCellNumber = _v[1];
    var _w = (0, react_1.useState)({ phone_number: "", country_code: "+267", country_abbreviation: "BW" }), spouseHomeNumber = _w[0], setSpouseHomeNumber = _w[1];
    var _x = (0, react_1.useState)({ phone_number: "", country_code: "+267", country_abbreviation: "BW" }), spouseWorkNumber = _x[0], setSpouseWorkNumber = _x[1];
    //Error Messages
    var _y = (0, react_1.useState)(""), nameMessage = _y[0], setNameMessage = _y[1];
    var _z = (0, react_1.useState)(""), surnameMessage = _z[0], setSurnameMessage = _z[1];
    var _0 = (0, react_1.useState)(""), idMessage = _0[0], setIdMessage = _0[1];
    var _1 = (0, react_1.useState)(""), postalAddressMessage = _1[0], setPostalAddressMessage = _1[1];
    var _2 = (0, react_1.useState)(""), homeAddressMessage = _2[0], setHomeAddressMessage = _2[1];
    var _3 = (0, react_1.useState)(""), genderMessage = _3[0], setGenderMessage = _3[1];
    var _4 = (0, react_1.useState)(""), marriageTypeMessage = _4[0], setMarriageTypeMessage = _4[1];
    //
    var _5 = (0, react_1.useState)(false), isSaving = _5[0], setIsSaving = _5[1];
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _6 = (0, react_1.useState)([]), addressList = _6[0], setAddressList = _6[1];
    (0, react_1.useEffect)(function () {
        var _a;
        if (user.uid) {
            (0, address_list_1.address_list)({
                user_id: (_a = user === null || user === void 0 ? void 0 : user.integration_id) !== null && _a !== void 0 ? _a : "",
            }).then(function (response) {
                if (response.success) {
                    setAddressList(response.content.addresses);
                }
                else {
                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
                }
            });
            (0, get_user_details_1.get_user_details)().then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                var _a, _b, _c, homeAddress;
                var _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
                return __generator(this, function (_y) {
                    switch (_y.label) {
                        case 0:
                            if (!response.success) return [3 /*break*/, 4];
                            setGender((_d = response === null || response === void 0 ? void 0 : response.content) === null || _d === void 0 ? void 0 : _d.gender);
                            setMarried((_e = response === null || response === void 0 ? void 0 : response.content) === null || _e === void 0 ? void 0 : _e.is_married);
                            setName((_f = response === null || response === void 0 ? void 0 : response.content) === null || _f === void 0 ? void 0 : _f.name);
                            setSurname((_g = response === null || response === void 0 ? void 0 : response.content) === null || _g === void 0 ? void 0 : _g.surname);
                            setIdNumber((_h = response === null || response === void 0 ? void 0 : response.content) === null || _h === void 0 ? void 0 : _h.id_number);
                            setSpouseName((_k = (_j = response === null || response === void 0 ? void 0 : response.content) === null || _j === void 0 ? void 0 : _j.spouse) === null || _k === void 0 ? void 0 : _k.name);
                            setSpouseSurname((_m = (_l = response === null || response === void 0 ? void 0 : response.content) === null || _l === void 0 ? void 0 : _l.spouse) === null || _m === void 0 ? void 0 : _m.surname);
                            _a = setSpouseCellNumber;
                            return [4 /*yield*/, (0, functions_1.convert_number)((_p = (_o = response === null || response === void 0 ? void 0 : response.content) === null || _o === void 0 ? void 0 : _o.spouse) === null || _p === void 0 ? void 0 : _p.cell_number)];
                        case 1:
                            _a.apply(void 0, [_y.sent()]);
                            _b = setSpouseHomeNumber;
                            return [4 /*yield*/, (0, functions_1.convert_number)((_r = (_q = response === null || response === void 0 ? void 0 : response.content) === null || _q === void 0 ? void 0 : _q.spouse) === null || _r === void 0 ? void 0 : _r.home_number)];
                        case 2:
                            _b.apply(void 0, [_y.sent()]);
                            _c = setSpouseWorkNumber;
                            return [4 /*yield*/, (0, functions_1.convert_number)((_t = (_s = response === null || response === void 0 ? void 0 : response.content) === null || _s === void 0 ? void 0 : _s.spouse) === null || _t === void 0 ? void 0 : _t.work_number)];
                        case 3:
                            _c.apply(void 0, [_y.sent()]);
                            setMarriageType((0, personal_details_1.normalizeMarriageType)((_u = response === null || response === void 0 ? void 0 : response.content) === null || _u === void 0 ? void 0 : _u.marriage_type));
                            // Load existing home address if available
                            if ((_w = (_v = response === null || response === void 0 ? void 0 : response.content) === null || _v === void 0 ? void 0 : _v.home_address) === null || _w === void 0 ? void 0 : _w.full_address) {
                                homeAddress = response.content.home_address;
                                setSelectedHomeAddress({
                                    full_address: homeAddress.full_address,
                                    latitude: homeAddress.latitude,
                                    longitude: homeAddress.longitude,
                                    isNew: false,
                                });
                                setHomeErf(homeAddress.homeErf);
                            }
                            // Load existing postal address
                            if ((_x = response === null || response === void 0 ? void 0 : response.content) === null || _x === void 0 ? void 0 : _x.postal_address) {
                                setSelectedPostalAddress(response.content.postal_address);
                            }
                            return [3 /*break*/, 5];
                        case 4:
                            dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
                            _y.label = 5;
                        case 5: return [2 /*return*/];
                    }
                });
            }); });
        }
        //
    }, [user]);
    var savePersonalDetails = function () {
        if (validateDetails()) {
            setIsSaving(true);
            // Build home_address object with location if coordinates are available
            var homeAddressData = {
                full_address: (selectedHomeAddress === null || selectedHomeAddress === void 0 ? void 0 : selectedHomeAddress.full_address) || "",
                date_updated: new Date(),
                homeErf: homeErf,
            };
            if (selectedHomeAddress && selectedHomeAddress.latitude !== 0) {
                homeAddressData.location = new firestore_1.GeoPoint(selectedHomeAddress.latitude, selectedHomeAddress.longitude);
            }
            // Get postal address as string
            var postalAddressString = typeof selectedPostalAddress === "string" ? selectedPostalAddress : (selectedPostalAddress === null || selectedPostalAddress === void 0 ? void 0 : selectedPostalAddress.full_address) || "";
            (0, update_advanced_user_details_1.update_advanced_user_details)({
                gender: gender,
                id_number: idNumber,
                is_married: married,
                marriage_type: marriageType,
                postal_address: postalAddressString,
                home_address: homeAddressData,
                spouse: {
                    date_updated: new Date(),
                    cell_number: spouseCellNumber,
                    home_number: spouseHomeNumber,
                    name: spouseName,
                    surname: spouseSurname,
                    work_number: spouseWorkNumber,
                },
            }).then(function (response) {
                setIsSaving(false);
                if (response.success) {
                    navigate("/advanced-personal-details/family-details");
                }
                else {
                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
                }
            });
        }
    };
    var clearErrorMessages = function () {
        setSpouseNameMessage("");
        setSpouseSurnameMessage("");
        setSpouseCellNumberMessage("");
        setSpouseHomeNumberMessage("");
        setSpouseWorkNumberMessage("");
        setNameMessage("");
        setSurnameMessage("");
        setIdMessage("");
        setPostalAddressMessage("");
        setHomeAddressMessage("");
        setGenderMessage("");
        setMarriageTypeMessage("");
    };
    var validateDetails = function () {
        clearErrorMessages();
        var messageCount = 0;
        // if (!name) {
        //   messageCount++;
        //   setNameMessage("Name is required.");
        // }
        // if (!surname) {
        //   messageCount++;
        //   setSurnameMessage("Surname is required.");
        // }
        // if (!idNumber) {
        //   messageCount++;
        //   setIdMessage("ID number is required.");
        // }
        // if (!postalAddress) {
        //   messageCount++;
        //   setPostalAddressMessage("Postal address is required.");
        // }
        // if (!homeAddress) {
        //   messageCount++;
        //   setHomeAddressMessage("Home address is required.");
        // }
        // if (!gender) {
        //   messageCount++;
        //   setGenderMessage("Gender is required.");
        // }
        if (married) {
            // if (!spouseName) {
            //   messageCount++;
            //   setSpouseNameMessage("Name is required.");
            // }
            // if (!spouseSurname) {
            //   messageCount++;
            //   setSpouseSurnameMessage("Surname is required.");
            // }
            if (spouseCellNumber === null || spouseCellNumber === void 0 ? void 0 : spouseCellNumber.phone_number) {
                var isValidPhoneNumber = doshx_controls_web_1.Utilities.isValidPhoneNumber(spouseCellNumber === null || spouseCellNumber === void 0 ? void 0 : spouseCellNumber.phone_number, spouseCellNumber === null || spouseCellNumber === void 0 ? void 0 : spouseCellNumber.country_abbreviation);
                if (!isValidPhoneNumber) {
                    messageCount++;
                    setSpouseCellNumberMessage("Invalid Number.");
                }
            }
            if (spouseHomeNumber === null || spouseHomeNumber === void 0 ? void 0 : spouseHomeNumber.phone_number) {
                var isValidPhoneNumber = doshx_controls_web_1.Utilities.isValidPhoneNumber(spouseHomeNumber === null || spouseHomeNumber === void 0 ? void 0 : spouseHomeNumber.phone_number, spouseHomeNumber === null || spouseHomeNumber === void 0 ? void 0 : spouseHomeNumber.country_abbreviation);
                if (!isValidPhoneNumber) {
                    messageCount++;
                    setSpouseHomeNumberMessage("Invalid Number.");
                }
            }
            if (spouseWorkNumber === null || spouseWorkNumber === void 0 ? void 0 : spouseWorkNumber.phone_number) {
                var isValidPhoneNumber = doshx_controls_web_1.Utilities.isValidPhoneNumber(spouseWorkNumber === null || spouseWorkNumber === void 0 ? void 0 : spouseWorkNumber.phone_number, spouseWorkNumber === null || spouseWorkNumber === void 0 ? void 0 : spouseWorkNumber.country_abbreviation);
                if (!isValidPhoneNumber) {
                    messageCount++;
                    setSpouseWorkNumberMessage("Invalid Number.");
                }
            }
            if (!marriageType) {
                messageCount++;
                setMarriageTypeMessage("Please select marriage type.");
            }
        }
        return messageCount ? false : true;
    };
    return (react_1.default.createElement("div", { className: "flex flex-col gap-8" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "flex flex-col gap-8" },
            react_1.default.createElement(page_path_1.PagePath, { path: [
                    {
                        page: "#",
                        title: "Advanced Personal Details",
                    },
                    {
                        title: "Personal Details",
                        active: true,
                    },
                ] }),
            react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Advanced Personal Details", textColor: "text-black", bold: true })),
                react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                    react_1.default.createElement("div", { className: "" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Personal Details", textColor: "text-black", bold: true })),
                    react_1.default.createElement("div", { className: "flex flex-col md:flex-row gap-3" },
                        react_1.default.createElement("div", { className: "w-full" },
                            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Name", disabled: user.SumSubApproved ? true : false, value: name, size: "small", errorText: nameMessage, onChange: function (v) { return setName(v); } })),
                        react_1.default.createElement("div", { className: "w-full" },
                            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Surname", disabled: user.SumSubApproved ? true : false, value: surname, size: "small", errorText: surnameMessage, onChange: function (v) { return setSurname(v); } }))),
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "ID Number", disabled: user.SumSubApproved ? true : false, value: idNumber, size: "small", errorText: idMessage, onChange: function (v) { return setIdNumber(v); } }),
                    react_1.default.createElement(AddressManager_1.default, { selectedHomeAddress: selectedHomeAddress, selectedPostalAddress: selectedPostalAddress, onHomeAddressChange: setSelectedHomeAddress, onPostalAddressChange: setSelectedPostalAddress, homeErf: homeErf, onHomeErfChange: setHomeErf, homeAddressError: homeAddressMessage, postalAddressError: postalAddressMessage, postalRequired: true }),
                    react_1.default.createElement(doshx_controls_web_1.DropdownControl, { options: personal_details_1.GENDERS, errorTextColor: "text-red-500", label: "Gender", size: "small", value: gender, errorText: genderMessage, onChange: function (v) {
                            setGender(v);
                        } })),
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Marital Status", textColor: "text-black", bold: true })),
                react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { label: "Married", value: married, onChange: function () {
                        setMarried(!married);
                    } }),
                married ? (react_1.default.createElement("div", { className: "flex flex-col  gap-4" },
                    react_1.default.createElement("div", { className: "" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Marriage Type", textColor: "text-black", bold: true })),
                    react_1.default.createElement(doshx_controls_web_1.DropdownControl, { options: personal_details_1.MARRIAGE_TYPES, errorTextColor: "text-red-500", label: "Marriage Type", size: "small", value: marriageType, errorText: marriageTypeMessage, onChange: function (v) {
                            setMarriageType(v);
                        } }),
                    react_1.default.createElement("div", { className: "" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Spouse Details", textColor: "text-black", bold: true })),
                    react_1.default.createElement("div", { className: "flex flex-col md:flex-row gap-3" },
                        react_1.default.createElement("div", { className: "w-full" },
                            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Name", value: spouseName, size: "small", errorText: spouseNameMessage, onChange: function (v) { return setSpouseName(v); } })),
                        react_1.default.createElement("div", { className: "w-full" },
                            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Surname", value: spouseSurname, size: "small", errorText: spouseSurnameMessage, onChange: function (v) { return setSpouseSurname(v); } }))),
                    react_1.default.createElement(doshx_controls_web_1.PhoneInputControl, { label: "Cell Number", value: spouseCellNumber === null || spouseCellNumber === void 0 ? void 0 : spouseCellNumber.phone_number, size: "small", errorText: spouseCellNumberMessage, defaultCountryCode: (_a = spouseCellNumber === null || spouseCellNumber === void 0 ? void 0 : spouseCellNumber.country_abbreviation) !== null && _a !== void 0 ? _a : "BW", showExtension: true, showFlag: true, onChange: function (v) {
                            return setSpouseCellNumber(__assign(__assign({}, spouseCellNumber), { phone_number: v }));
                        }, onExtensionChange: function (ext, code) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                setSpouseCellNumber({
                                    phone_number: spouseCellNumber === null || spouseCellNumber === void 0 ? void 0 : spouseCellNumber.phone_number,
                                    country_code: ext,
                                    country_abbreviation: code,
                                });
                                return [2 /*return*/];
                            });
                        }); }, international: true }),
                    react_1.default.createElement(doshx_controls_web_1.PhoneInputControl, { label: "Work Number", value: spouseWorkNumber === null || spouseWorkNumber === void 0 ? void 0 : spouseWorkNumber.phone_number, size: "small", errorText: spouseWorkNumberMessage, defaultCountryCode: (_b = spouseWorkNumber === null || spouseWorkNumber === void 0 ? void 0 : spouseWorkNumber.country_abbreviation) !== null && _b !== void 0 ? _b : "BW", showExtension: true, showFlag: true, onChange: function (v) {
                            return setSpouseWorkNumber(__assign(__assign({}, spouseWorkNumber), { phone_number: v }));
                        }, onExtensionChange: function (ext, code) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                setSpouseWorkNumber({
                                    phone_number: spouseWorkNumber === null || spouseWorkNumber === void 0 ? void 0 : spouseWorkNumber.phone_number,
                                    country_code: ext,
                                    country_abbreviation: code,
                                });
                                return [2 /*return*/];
                            });
                        }); }, international: true }),
                    react_1.default.createElement(doshx_controls_web_1.PhoneInputControl, { label: "Home Number", value: spouseHomeNumber === null || spouseHomeNumber === void 0 ? void 0 : spouseHomeNumber.phone_number, size: "small", errorText: spouseHomeNumberMessage, defaultCountryCode: (_c = spouseHomeNumber === null || spouseHomeNumber === void 0 ? void 0 : spouseHomeNumber.country_abbreviation) !== null && _c !== void 0 ? _c : "BW", showExtension: true, showFlag: true, onChange: function (v) {
                            return setSpouseHomeNumber(__assign(__assign({}, spouseHomeNumber), { phone_number: v }));
                        }, onExtensionChange: function (ext, code) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                setSpouseHomeNumber({
                                    phone_number: spouseHomeNumber === null || spouseHomeNumber === void 0 ? void 0 : spouseHomeNumber.phone_number,
                                    country_code: ext,
                                    country_abbreviation: code,
                                });
                                return [2 /*return*/];
                            });
                        }); }, international: true }))) : null,
                react_1.default.createElement("div", { className: "flex justify-center" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Save & Proceed", loading: isSaving, enabled: !isSaving, backgroundColor: "bg-secondary", size: "small", endIcon: pro_solid_svg_icons_1.faArrowRight, onClick: function () {
                            savePersonalDetails();
                        } }))))));
};
exports.PersonalDetailsPage = PersonalDetailsPage;
